import { useQuery } from '@apollo/client'
import { FC, useRef } from 'react'

import { ArtistsFromCategoriesQuery, ArtistsFromCategoriesQueryVariables } from 'gql'
import { flatAPropertyInArrayOfObj, getImageUrl } from 'utils'
import { STAR } from 'routes/paths'
import { useOnScreen } from '~hooks'
import { Card, Wrapper } from '~ui'
import { RowCategories } from 'pages/search'
import Carousel from 'components/carousel'
import { STARS_IN_CATEGORY_QUERY } from 'gql/artist/queries'

type CategoryEventsSliderProps = {
  mainCategory?: string
  categoriesRaw?: RowCategories[]
  title?: string
}
const CategoryEventsSlider: FC<CategoryEventsSliderProps> = ({
  categoriesRaw,
  mainCategory,
  title,
}) => {
  const categoriesList = flatAPropertyInArrayOfObj(
    categoriesRaw?.filter((category) => category.id === mainCategory),
    'categories'
  ).map(({ id }) => id)

  const ref = useRef<HTMLDivElement>(null)

  const { wasViewed } = useOnScreen(ref, '10px')

  const { data, loading, fetchMore } = useQuery<
    ArtistsFromCategoriesQuery,
    ArtistsFromCategoriesQueryVariables
  >(STARS_IN_CATEGORY_QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      first: 8,
      categories_Contains: categoriesList.length ? categoriesList : mainCategory,
      status: 'public',
      orderBy: '-updated',
    },
    skip: !wasViewed,
  })

  const loadMore = data?.allArtists.pageInfo?.hasNextPage
    ? () => fetchMore({ variables: { after: data.allArtists.pageInfo.endCursor } })
    : null

  return (
    <Wrapper ref={ref} style={{ padding: '0 0 0 1em' }}>
      <Carousel<ArtistsFromCategoriesQuery['allArtists']['edges']['0']['node']>
        dataSource={data?.allArtists.edges.map(({ node }) => node)}
        renderItem={({ fullName, id, slug, file }) => (
          <Card
            key={id}
            imageSrc={getImageUrl(file, 500, 400)}
            linkTitle="Get Tickets"
            title={fullName}
            link={STAR(slug)}
          />
        )}
        loading={loading || !wasViewed}
        title={title}
        fetchMore={loadMore}
      />
    </Wrapper>
  )
}

export default CategoryEventsSlider
